import { States } from '@yandex-360/telemost-sdk/audio-diagnostics';

type GetOutputDiagnosticBtnTitleFunction = (state: States, isHovered?: boolean) => string;

export const getOutputDiagnosticBtnTitle: GetOutputDiagnosticBtnTitleFunction = (state, isHovered = true) => {
    const states = {
        idle: 'diagnostic-play-btn',
        recording: 'diagnostic-stop-playing-btn',
        playing: isHovered ? 'diagnostic-stop-playing-btn' : 'diagnostic-playing-melody',
        destroyed: 'diagnostic-play-btn',
    };

    return states[state];
};
